import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronDown } from 'react-bootstrap-icons';
import articles from '../../pages/tudasbazis/articles/registry';
import { getMenuIcon } from '../sidebar/menuGroups';

// A "Tudás bázis" fejléc-menüpont, saját legördülővel. A cikklista tisztán
// frontend-forrásból (articles/registry.js) jön, nem a DB-vezérelt menuItems-ből
// — így egy új cikk felvétele sosem igényel DB-módosítást, ld. griff skill.
function KnowledgeBaseNavItem({ item }) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    if (!articles.length) {
        return (
            <NavLink to={item.MenuPath} className="header-direct-link" title="Tudás bázis">
                {getMenuIcon(item.MenuIcon, 18)}
                <span className="header-direct-link-text">Tudás bázis</span>
            </NavLink>
        );
    }

    return (
        <div className="kb-nav-item" ref={containerRef}>
            <div className="header-direct-link kb-nav-link">
                <NavLink to={item.MenuPath} className="kb-nav-link-main" title="Tudás bázis">
                    {getMenuIcon(item.MenuIcon, 18)}
                    <span className="header-direct-link-text">Tudás bázis</span>
                </NavLink>
                <button
                    type="button"
                    className="kb-nav-toggle"
                    aria-label="Cikkek listája"
                    aria-expanded={open}
                    onClick={() => setOpen((o) => !o)}
                >
                    <ChevronDown size={14} />
                </button>
            </div>
            {open && (
                <div className="kb-nav-dropdown">
                    {articles.map((article) => (
                        <NavLink
                            key={article.slug}
                            to={`/tudasbazis/${article.slug}`}
                            className="kb-nav-dropdown-item"
                            onClick={() => setOpen(false)}
                        >
                            {article.menuLabel}
                        </NavLink>
                    ))}
                </div>
            )}
        </div>
    );
}

export default KnowledgeBaseNavItem;
